import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSList
} from "@wingspanhq/fe-component-library";
import { Batch, Engagement } from "@wingspanhq/wingspan-api-sdk";

import { CONTRACTOR_ENTITY_LABEL } from "./constants";
import { selectorImportBatchDisplayStatus } from "../../selectors/selectorImportBatchDisplayStatus";
import { selectorImportBatchUploadedFilename } from "../../selectors/selectorImportBatchUploadedFilename";

type Props = {
  batch: Batch;
  engagement?: Engagement;
};

export const ContractorBatchDetailsWidget: React.FC<Props> = ({
  batch,
  engagement
}) => (
  <WSCard header="Details" divider>
    <WSList gap="XL">
      <WSDataItem
        inline
        label="Original spreadsheet"
        value={
          selectorImportBatchUploadedFilename({
            batch,
            entityLabel: CONTRACTOR_ENTITY_LABEL
          }) || "--"
        }
      />
      <WSDataItem
        inline
        label="Imported to contractors"
        value={selectorImportBatchDisplayStatus(batch.status)}
      />
      <WSDataItem
        inline
        label="Created"
        value={
          batch.events?.createdAt
            ? toWSDateString(batch.events.createdAt)
            : "--"
        }
      />
      {/* TODO(v3-gap): v3 `Batch` carries no creator — see the gaps doc for the
          missing `createdBy`/actor on batches. */}
      <WSDataItem inline label="Creator" value="--" />
      <WSDataItem inline label="Engagement" value={engagement?.name} />
    </WSList>
  </WSCard>
);
